import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ChatJSLineChart } from "../../../../Constant";
import { Doughnut } from "react-chartjs-2";
import { DOUGHNUT_CHART_DATA, DOUGHNUT_CHART_OPTION } from "../../../../Data/Charts/ChartJS";

const DoughnutChart = () => {
  return (
    <Col xl="6" ms="12" className="box-col-6">
      <Card>
        <CommonCardHeader title={ChatJSLineChart} />
        <CardBody className="chart-block">
          <Doughnut id="myDoughnutGraph" data={DOUGHNUT_CHART_DATA} options={DOUGHNUT_CHART_OPTION} width={734} height={335} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default DoughnutChart;
